module.exports = __webpack_public_path__ + "img/3.b7f2dc5c.jpg";